import { Checkbox, FormControlLabel } from '@mui/material';

import type { NoMaladaptiveBehaviorCheckboxProps } from './types';

export default function NoMaladaptiveBehaviorCheckbox({
  checked,
  disabled = false,
  onChange,
}: NoMaladaptiveBehaviorCheckboxProps) {
  return (
    <FormControlLabel
      sx={{ alignSelf: 'flex-start' }}
      control={
        <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={(_event, value) => onChange(value)}
        />
      }
      label="No Maladaptive behavior"
    />
  );
}
